import { buildStoreDataUrl, API_CONFIG } from "@/shared/configs/apiConfig.js"
import sample from '../raws/get.json'

export default {
  url({ companyId }) {
    companyId = 'jnnuf'
    return buildStoreDataUrl({ service: 'rapidoo-restaurant', userId: companyId })
  },
  parse(raw = {}, payload = { type: '' }) {
    raw = sample.packageDeliveries
    if (raw?.statusCode == 404)
      return {
        statusCode: 404,
        message: 'Restaurant non trouvé',
        data: null,
        currency: 'XOF',
      }

    if (raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        data: null,
        currency: 'XOF',
      }

    return {
      statusCode: 200,
      message: 'ok',
      data: (raw.data || []).map(el => {
        return {
          id: el.id,
          deliveryId: el.deliveryId,
          packageType: el.packageType,
          dimensions: el.dimensions,
          weight: el.weight,
          distance: el.distance,
          totalCost: el.totalCost,
          deliveryDate: el.deliveryDate,
        }
      }),
    }
  },
}
